(function (window) {
  window.__env = window.__env || {};
  window.__env.mixpanelToken = '4107afd9848ff6b888bc3ece69b95f9f';
  window.__env.isDevelopment = false;
  window.__env.s3AssessmentPdf = 'beehire-assessment-pdf';
  window.__env.mapbox_access_token = 'pk.eyJ1Ijoic2ltb25iZWVoaXJlIiwiYSI6ImNtOGZ0eno1ZzBibmIyaXM3Ym00bzg5cXgifQ.DrzY8Lp1GIu_hsxqttOmDA';
}(this));